import { c as i } from "../../../index-34b1f277.js";
import { CheckboxListAnatomy as e } from "./CheckboxList.anatomy.es.js";
const { defineMultiStyleConfig: t, definePartsStyle: o } = i(
  e.keys
), n = o({
  checkboxListContainer: {
    display: "flex",
    flexDirection: "column",
    width: "full",
    paddingLeft: "spacing-200",
    gap: "spacing-50"
  },
  checkboxListContainerPositionRight: {
    display: "flex",
    flexDirection: "column",
    width: "full",
    paddingLeft: 0,
    gap: "spacing-50"
  },
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "0.25",
    width: "full",
    alignItems: "flex-start"
  },
  individualCheckbox: {
    padding: "spacing-100"
  },
  individualCheckboxRight: {
    paddingX: 0
  },
  rootCheckbox: {
    height: "size-400"
  },
  rootCheckboxRight: {
    fontWeight: "medium"
  }
}), c = t({
  baseStyle: n
});
export {
  c as CheckboxList
};
//# sourceMappingURL=CheckboxList.es.js.map
